import { el, setAttr, setChildren } from 'redom';

class ProfilePictureDisplay {

  constructor(configuration = {}) {

    this.onClick = configuration.onClick || function noOp() {};

    this.el = el('label.inbox-profile-picture', this.getElementOptions(configuration));

  }

  getElementOptions(configuration) {

    const options = { onclick: this.handleClick.bind(this) };

    if (typeof configuration.onClick === 'function') {
      options.class = 'clickable';
    }

    return options;

  }

  handleClick() {

    this.onClick();

  }

  updateImage(helpSeeker) {

    const profilePicture = helpSeeker.profilePicture;
    const path = ProfilePictureDisplay.determineProfilePicturePath(profilePicture);

    setAttr(this.el, { style: { 'background-image': `url(${path})` } });

  }

  tryUpdateOnlineStatus(helpSeeker) {

    if (typeof helpSeeker.status !== 'string') {
      setChildren(this.el, []);
      return;
    }

    setChildren(this.el, [
      el('span.online-status-indicator', {
        class: helpSeeker.status.toLowerCase()
      })
    ]);

  }

  update(helpSeeker) {

    this.updateImage(helpSeeker);
    this.tryUpdateOnlineStatus(helpSeeker);

  }

  static determineProfilePicturePath(profilePicture) {

    let path = import.meta.env.REACT_APP_ASSETS_URL + '/assets/images/default-profile-picture.png';

    if (profilePicture === void 0 || profilePicture === null) {
      return path;
    } else if (profilePicture.url === '') {
      return path;
    } else {
      return profilePicture.url;
    }

  }

}

export default ProfilePictureDisplay;